import React, { useState } from 'react';
import '../styles/ProgramQuiz.css';

const communityAvatars = [
  { src: '/assets/testimonials/Erica.jpg', alt: 'Erica' },
  { src: '/assets/testimonials/Carolyn.jpg', alt: 'Carolyn' },
  { src: '/assets/testimonials/Anuradha.jpg', alt: 'Anuradha' },
  { src: '/assets/testimonials/Sajani.jpg', alt: 'Sajani' },
];

const programs = {
  P1: {
    id: 'P1',
    name: '14 Days',
    tagline: 'Quick Reset Program',
    description: 'A short, focused program to reset your habits and build momentum.',
    features: ['14 days of guided workouts', 'Quick daily sessions', 'Habit reset focus', 'Email support'],
    link: '/programs/P1',
    image: '/uploads/programs/program1.jpg'
  },
  P2: {
    id: 'P2',
    name: '21 Days',
    tagline: 'Build Consistency',
    description: 'Three weeks to establish a consistent workout and nutrition routine.',
    features: ['21 structured workouts', 'Nutrition guidance', 'Progress tracking', 'Community access'],
    link: '/programs/P2',
    image: '/uploads/programs/program2.jpg'
  },
  P3: {
    id: 'P3',
    name: 'Post Partum Program',
    tagline: 'Safe Recovery for New Moms',
    description: 'Specialized program for mothers 0-18+ months postpartum.',
    features: ['Core-safe exercises', 'Pelvic floor recovery', 'Diastasis recti safe', 'Mom community'],
    link: '/programs/P3',
    image: '/uploads/programs/program3.jpg'
  },
  P4: {
    id: 'P4',
    name: 'Virtually Fit with Daniella',
    tagline: 'Monthly Structure & Accountability',
    description: 'Ongoing monthly support with structured workouts and accountability.',
    features: ['Live virtual sessions', 'Monthly workout plans', 'Direct coach access', 'Private community'],
    link: '/programs/P4',
    image: '/uploads/programs/program4.jpg'
  },
  P5: {
    id: 'P5',
    name: 'Undiet in 60',
    tagline: 'Fix Your Relationship with Food',
    description: '60-day program to overcome emotional eating and break free from diet culture.',
    features: ['Mindset coaching', 'Intuitive eating guide', 'Emotional eating toolkit', 'Weekly live Q&A'],
    link: '/programs/P5',
    image: '/uploads/programs/program1.jpg'
  },
  P6: {
    id: 'P6',
    name: '90 Days to a Sustainable Healthy Lifestyle',
    tagline: 'Complete Lifestyle Transformation',
    description: 'Comprehensive 90-day program for lasting change.',
    features: ['Complete workout library', 'Personalized nutrition', '1-on-1 check-ins', 'Lifetime access'],
    link: '/programs/P6',
    image: '/uploads/programs/program2.jpg'
  }
};

// Priority order for tie-breaking
const priorityOrder = ['P3', 'P6', 'P5', 'P4', 'P2', 'P1'];

const questions = [
  {
    id: 1,
    question: "What best describes you right now?",
    options: [
      { value: 'A', label: 'I just had a baby (0–18+ months postpartum)', scores: { P3: 5 } },
      { value: 'B', label: 'I want a quick reset to get back on track', scores: { P1: 3, P2: 3 } },
      { value: 'C', label: 'I need structure and accountability monthly', scores: { P4: 4, P6: 2 } },
      { value: 'D', label: "I've dieted for years and I'm tired of it", scores: { P5: 5 } },
      { value: 'E', label: "I'm ready for a full lifestyle transformation", scores: { P6: 6 } }
    ]
  },
  {
    id: 2,
    question: "What's your biggest struggle right now?",
    options: [
      { value: 'A', label: "I start but don't stay consistent", scores: { P2: 3, P6: 3 } },
      { value: 'B', label: 'Emotional eating / food guilt', scores: { P5: 6 } },
      { value: 'C', label: 'Weak core & body changes after baby', scores: { P3: 6 } },
      { value: 'D', label: 'No routine or accountability', scores: { P4: 4, P6: 2 } },
      { value: 'E', label: 'I want lasting change, not quick fixes', scores: { P6: 5 } }
    ]
  },
  {
    id: 3,
    question: 'How much time can you realistically commit weekly?',
    options: [
      { value: 'A', label: '5-20 mins, 3–4x/week', scores: { P1: 4, P3: 2 } },
      { value: 'B', label: '30 mins, 4–5x/week', scores: { P2: 4, P4: 3 } },
      { value: 'C', label: "45+ mins, I'm serious", scores: { P6: 6, P5: 2 } }
    ]
  },
  {
    id: 4,
    question: 'How would you describe your current fitness level?',
    options: [
      { value: 'A', label: "I'm just getting started (or restarting after a long break)", scores: { P1: 4, P3: 3 } },
      { value: 'B', label: "I work out occasionally but I'm inconsistent", scores: { P2: 3, P4: 3 } },
      { value: 'C', label: 'I train regularly and want more structure', scores: { P6: 4, P4: 2 } }
    ]
  },
  {
    id: 5,
    question: 'What feels realistic for you right now?',
    options: [
      { value: 'A', label: 'I just need to start and build momentum', scores: { P1: 4, P2: 3 } },
      { value: 'B', label: 'I want to fix my eating habits properly', scores: { P5: 5 } },
      { value: 'C', label: "I'm ready to change my lifestyle overall", scores: { P6: 6 } },
      { value: 'D', label: 'I want ongoing structure and support with workouts', scores: { P4: 5 } }
    ]
  },
  {
    id: 6,
    question: 'Where do you feel you are right now in your journey?',
    options: [
      { value: 'A', label: 'I just need a small step to get started', scores: { P1: 4, P2: 2 } },
      { value: 'B', label: "I'm ready to show up consistently", scores: { P2: 3, P4: 3 } },
      { value: 'C', label: "I'm fully committed to long-term change", scores: { P6: 7, P5: 2 } }
    ]
  }
];

export function ProgramQuiz() {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [recommendedProgram, setRecommendedProgram] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleAnswer = (questionId, option) => {
    if (isAnimating) return;
    setAnswers({ ...answers, [questionId]: option });
  };

  const handleNext = () => {
    if (!answers[currentQuestion.id] || isAnimating) return;
    
    setIsAnimating(true);
    
    if (currentStep < questions.length - 1) {
      setTimeout(() => {
        setCurrentStep(currentStep + 1);
        setIsAnimating(false);
      }, 300);
    } else {
      setTimeout(() => {
        calculateResult();
        setIsAnimating(false);
      }, 300);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0 && !isAnimating) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentStep(currentStep - 1);
        setIsAnimating(false);
      }, 250);
    }
  };

  const calculateResult = () => {
    const scores = { P1: 0, P2: 0, P3: 0, P4: 0, P5: 0, P6: 0 };
    
    Object.values(answers).forEach(option => {
      if (option && option.scores) {
        Object.entries(option.scores).forEach(([program, score]) => {
          if (scores.hasOwnProperty(program)) {
            scores[program] += score;
          }
        });
      }
    });

    // Find the highest score
    let maxScore = -1;
    let winners = [];
    
    Object.entries(scores).forEach(([program, score]) => {
      if (score > maxScore) {
        maxScore = score;
        winners = [program];
      } else if (score === maxScore) {
        winners.push(program);
      }
    });

    // If tie, use priority order (P3 > P6 > P5 > P4 > P2 > P1)
    let winner = winners[0];
    if (winners.length > 1) {
      for (const program of priorityOrder) {
        if (winners.includes(program)) {
          winner = program;
          break;
        }
      }
    }

    setRecommendedProgram(programs[winner]);
    setShowResult(true);
  };

  const restartQuiz = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentStep(0);
      setAnswers({});
      setShowResult(false);
      setRecommendedProgram(null);
      setIsAnimating(false);
    }, 250);
  };

  const currentQuestion = questions[currentStep];
  const isAnswerSelected = answers[currentQuestion.id];

  // Result View
  if (showResult && recommendedProgram) {
    return (
      <section id="program-quiz" className="quiz-section">
        <div className="quiz-layout">
          {/* Left Side - Content */}
          <div className="quiz-content-left">
            <h2 className="quiz-main-title">Your Perfect Program</h2>
            <p className="quiz-main-subtitle">
              Based on your answers, we&apos;ve found the ideal fitness program tailored just for you.
            </p>
            
            <div className="quiz-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">✓</span>
                <span>Personalized recommendation</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">✓</span>
                <span>30-second assessment</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">✓</span>
                <span>1000+ successful members</span>
              </div>
            </div>

            <div className="quiz-avatars">
              <div className="avatar-stack">
                {communityAvatars.map((avatar) => (
                  <img key={avatar.src} src={avatar.src} alt={avatar.alt} className="quiz-avatar" />
                ))}
              </div>
              <span className="avatar-text">Join our community today</span>
            </div>
          </div>

          {/* Right Side - Result Card */}
          <div className={`quiz-form-right ${isAnimating ? 'slide-out' : 'slide-in'}`}>
            <div className="quiz-result-card">
              {/* Header with Image */}
              <div className="result-header-bg">
                <img src={recommendedProgram.image} alt={recommendedProgram.name} />
                <div className="result-header-overlay"></div>
                <div className="result-header-content">
                  <h3 className="result-title">{recommendedProgram.name}</h3>
                  <p className="result-tagline">{recommendedProgram.tagline}</p>
                </div>
              </div>

              {/* Body */}
              <div className="result-body">
                <p className="result-desc">{recommendedProgram.description}</p>

                <div className="result-features-list">
                  {recommendedProgram.features.map((feature, index) => (
                    <div key={index} className="result-feature-item">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Actions */}
              <div className="result-actions">
                <a href={recommendedProgram.link} className="btn btn-primary btn-get-program">
                  See My Program
                  <span className="arrow">→</span>
                </a>
                <a href="/book-call" className="btn btn-secondary btn-clarity-call">
                  Not sure? Book a Clarity Call
                </a>
                <button className="btn-retake" onClick={restartQuiz}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="23 4 23 10 17 10"/>
                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                  </svg>
                  Retake Quiz
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Quiz View
  return (
    <section id="program-quiz" className="quiz-section">
      <div className="quiz-layout">
        {/* Left Side - Content */}
        <div className="quiz-content-left">
          <h2 className="quiz-main-title">Which Program is for Me?</h2>
          <p className="quiz-main-subtitle">
            Take our quick 30-second quiz to discover the perfect fitness program tailored to your goals, schedule, and preferences.
          </p>
          
          <div className="quiz-benefits">
            <div className="benefit-item">
              <span className="benefit-icon">✓</span>
              <span>Personalized recommendation</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">✓</span>
              <span>Takes only 30 seconds</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">✓</span>
              <span>1000+ successful members</span>
            </div>
          </div>

          <div className="quiz-avatars">
            <div className="avatar-stack">
              {communityAvatars.map((avatar) => (
                <img key={avatar.src} src={avatar.src} alt={avatar.alt} className="quiz-avatar" />
              ))}
            </div>
            <span className="avatar-text">Join 1000+ members worldwide</span>
          </div>
        </div>

        {/* Right Side - Quiz Form */}
        <div className={`quiz-form-right ${isAnimating ? 'slide-out' : 'slide-in'}`}>
          <div className="quiz-card">
            {/* Steps */}
            <div className="quiz-steps">
              {questions.map((_, index) => (
                <div key={index} className={`step ${index < currentStep ? 'completed' : ''} ${index === currentStep ? 'active' : ''}`}>
                  <div className="step-circle">
                    {index < currentStep ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                    ) : (
                      index + 1
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Question */}
            <div className="question-header">
              <span className="question-step">Question {currentStep + 1} of {questions.length}</span>
              <h3 className="question-text">{currentQuestion.question}</h3>
            </div>

            {/* Options */}
            <div className="options-grid">
              {currentQuestion.options.map((option, index) => (
                <button
                  key={index}
                  className={`option-card ${answers[currentQuestion.id] === option ? 'selected' : ''}`}
                  onClick={() => handleAnswer(currentQuestion.id, option)}
                >
                  <div className="option-radio">
                    {answers[currentQuestion.id] === option && <div className="radio-fill"></div>}
                  </div>
                  <div className="option-content">
                    <span className="option-label">{option.label}</span>
                    <span className="option-description">{option.description}</span>
                  </div>
                </button>
              ))}
            </div>

            {/* Navigation */}
            <div className="quiz-navigation">
              <button className="btn-nav btn-prev" onClick={handlePrevious} disabled={currentStep === 0}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
                Back
              </button>
              
              <button 
                className="btn-nav btn-next"
                onClick={handleNext}
                disabled={!isAnswerSelected}
              >
                {currentStep === questions.length - 1 ? 'Get My Program' : 'Continue'}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
